import { HStack, Text, VStack } from '@chakra-ui/react';
import { getShortDate, parseDateRange } from '../../utils';

export const EventDate = ({ eventDate }: { eventDate: string }) => {
  const parsedDate = parseDateRange(eventDate);
  const shortStartDate = getShortDate(parsedDate.startDate ?? '');
  const shortEndDate = getShortDate(parsedDate.endDate ?? '');
  const showRange = Boolean(
    parsedDate.startDate &&
      shortEndDate &&
      shortEndDate.length > 0 &&
      (shortStartDate[0] !== shortEndDate[0] ||
        shortStartDate[1] !== shortEndDate[1])
  );

  return (
    <HStack spacing={showRange ? [1, 1, 1, 2] : 0}>
      <VStack spacing={0} data-testid="event-date">
        <Text fontSize="1.6rem" lineHeight={1}>
          {shortStartDate[1]}
        </Text>
        <Text fontSize="sm">{shortStartDate[0]}</Text>
      </VStack>
      {showRange && (
        <>
          <Text fontSize="1.6rem" lineHeight={1}>
            -
          </Text>
          <VStack spacing={0} data-testid="event-end-date">
            <Text fontSize="1.6rem" lineHeight={1}>
              {shortEndDate[1]}
            </Text>
            <Text fontSize="sm">{shortEndDate[0]}</Text>
          </VStack>
        </>
      )}
    </HStack>
  );
};
